import React, { useState, useEffect } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AutoResizeTextArea from "../../../../components/ui/AutoResizeTextarea/AutosizeTextarea";
import {
  faChevronCircleRight,
  faChevronCircleDown,
  faTrash,
  faPlusCircle,
} from "@fortawesome/free-solid-svg-icons";

function Completed({ objective, toggleSubTask, title, deleteSubtask }) {
  const [collapse, setCollapse] = useState(false);
  const [live, setLive] = useState();

  const handleCollapse = () => {
    setCollapse((prev) => !prev);
  };

  useEffect(() => {
    const len = objective?.subTasks?.filter((e) => e.completed === 1).length;
    setLive(len > 0);
  }, [objective]);

  const CompletedArr = () => {
    const completedTasks = objective?.subTasks?.filter(
      (t) => t.completed === 1,
    );
    if (!completedTasks) return null;

    return completedTasks.map((task) => (
      <div className="objective__col--task-active-collapse" key={task.id}>
        <strong className="task--input completed">{task.description}</strong>
        <div
          className="task__icon"
          onClick={() => toggleSubTask(task.id, title)}
        >
          <FontAwesomeIcon
            className="task__icon--icon"
            icon={faPlusCircle}
            style={{ color: "#004a22" }}
          />
        </div>

        <div
          className="task__icon"
          onClick={() => deleteSubtask(title, task.id)}
        >
          <FontAwesomeIcon
            className="task__icon--icon"
            icon={faTrash}
            style={{ color: "#004a22" }}
          />
        </div>
      </div>
    ));
  };

  return (
    <div className={live ? "collapse--wrapper" : "collapse--wrapper none"}>
      <div className="collapse--row" onClick={handleCollapse}>
        <label className="score--label">Completed</label>{" "}
        <FontAwesomeIcon
          style={{ color: "#e2dfcf" }}
          icon={collapse ? faChevronCircleDown : faChevronCircleRight}
        />
      </div>
      <div className={collapse ? "collapse--active" : "collapse"}>
        {CompletedArr()}
      </div>
    </div>
  );
}

export default Completed;
